import { Cookies } from 'react-cookie';

import { TechnicianFormData, userOnClientCreationResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const addSiteContactForSite = async (siteContact: TechnicianFormData) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.post('clients/create-client-site-contact/', siteContact, {
    headers: {
      Authorization: token,
    },
  });
  return response.data as userOnClientCreationResponse;
};
